<template>
    <section class="mod mod1">
        <!-- 新版改动需注释 -->
        <h2 class="mod-tit">
            今日南向资金
            <!-- <router-link
                class="fr link-more"
                :to="{ name: 'todaylist', params: { id: 'nxzj' } }"
            >
                查看更多
            </router-link> -->
        </h2>
        <!-- 结束 -->
        <div class="nav-sub flex">
            <span
                v-for="(item, i) in ZJTodayNavs"
                :key="i"
                :class="curZJToday == i ? 'cur' : ''"
                @click="setTable(item, i)"
            >
                {{ item }}
            </span>
        </div>
        <!-- 南向 -->
        <div class="nav-sub-cont">
            <!-- 新版改动需注释 -->
            <!-- <div class="chart-legent flex"> -->
            <!-- 结束 -->

            <!-- 新版改动需解开 -->
            <div class="chart-info-box">
                <div class="chart-info-date">
                    数据日期：{{ pagealtogether.quotaDate }}
                </div>
                <div class="chart-info flex" v-if="curZJToday==1">
                    <div>沪股通<strong :class="pagealtogether.nx_h_saleTotal | formateRedGreen">{{pagealtogether.nx_h_saleTotal|formatePrefixData}}</strong></div>
                    <div>深股通<strong :class="pagealtogether.nx_s_saleTotal | formateRedGreen">{{pagealtogether.nx_s_saleTotal|formatePrefixData}}</strong></div>
                </div>
                <div class="chart-info flex" v-else>
                    <div>两市合计<strong :class="nxzj_hj | formateRedGreen">{{nxzj_hj}}亿</strong></div>
                    <div>沪股通<strong :class="ggt_h_hj | formateRedGreen">{{ggt_h_hj}}亿</strong></div>
                    <div>深股通<strong :class="ggt_s_hj | formateRedGreen">{{ggt_s_hj}}亿</strong></div>
                </div>
            </div>
            <div class="chart-legent flex" v-if="curZJToday==0">

                <span
                    v-for="(title, i) in legents"
                    :class="{
                        'legent-blue': i == 0,
                        'legent-org': i == 1,
                        'legent-red': i == 2,
                    }"
                    :key="i"
                    class="legent"
                    v-show="!(curZJToday == 1 && i == 0)"
                >
                    {{ title }}
                </span>
                <!-- 结束 -->

                <!-- 新版改动需注释 -->
                <!-- <div
                    class="legent-more"
                    @click="showLineMore = !showLineMore"
                    :class="showLineMore ? 'down' : ''"
                >
                    <span class="legent-black legent">
                        {{ LineMoreArray[LineMoreIndex] }}
                    </span>
                    <ul v-show="showLineMore">
                        <li
                            v-for="(title, i) in LineMoreArray"
                            :class="LineMoreIndex == i ? 'actived' : ''"
                            :key="i"
                             @click="setZs(title, i)"
                        >
                            {{ title }}
                        </li>
                    </ul>
                </div> -->
                <!-- 结束 -->
            </div>
            <!--<div v-if="showInfo">
                <div class="chart chart-today" id="line2"></div>
                <div class="chart-info flex">
                    <div>
                        两市合计<strong :class="nxzj_hj | formateRedGreen"
                            >{{ nxzj_hj }}亿</strong
                        >
                    </div>
                    <div>
                        港股通(沪)<strong :class="ggt_h_hj | formateRedGreen"
                            >{{ ggt_h_hj }}亿</strong
                        >
                    </div>
                    <div>
                        港股通(深)<strong :class="ggt_s_hj | formateRedGreen"
                            >{{ ggt_s_hj }}亿</strong
                        >
                    </div>
                </div>
            </div>
            <div
                style="
                    height: 1.5rem;
                    text-align: center;
                    line-height: 1.5rem;
                    font-size: 14px;
                    color: #999999;
                "
                v-else
            >
                -暂无数据-
            </div>-->
            <div  v-show="curZJToday==0">
                <div class="chart chart-today" id="line"></div>
            </div>
            <p class="remark"  v-show="curZJToday==1">
                说明：<br>

                ①沪股通和深股通每日额度各为{{pagealtogether.nx_buyTotal}}亿元人币，两市合计额度{{pagealtogether.nx_buyTotal * 2}}亿人民币；</br>②当日额度余额大于或等于30%时，显示“额度充足”；小于30%时，实时显示额度余额。
            </p>

        </div>
    </section>
</template>

<script>
// import Vue from 'vue'
import { nxzjmin, nxzjyemin, getYunSpjToSf } from "@/api/index.js";
import { mapState } from "vuex";

export default {
    name: "TodayNorthAmount",
    data() {
        return {
            pagealtogether:{
                bx_buyTotal:0,
                nx_buyTotal:0,
                bx_h_bsTotal: 0,
                bx_h_saleTotal: 0,
                bx_s_bsTotal: 0,
                bx_s_saleTotal: 0,
                nx_h_bsTotal: 0,
                nx_h_saleTotal: 0,
                nx_s_bsTotal: 0,
                nx_s_saleTotal: 0
            },
            dialogContent: [
                '每日收市后更新成交总额',
                '①沪股通和深股通每日额度各为520亿元人币，两市合计额度1040亿人民币；\n②当日额度余额大于或等于30%时，显示“额度充足”；小于30%时，实时显示额度余额。',
            ],
            myChart:'',

            curZJToday: 0,
            ZJTodayNavs: ['资金净流入','额度余额'],
            // ZJTodayNavs: ["资金流向", "资金净流入", "资金余额", "未成交委买"],
            legents: ["合计", "港股通(沪)", "港股通(深)"],
            showLineMore: false,
            LineMoreIndex: 0,
            LineMoreArray: ["上证指数", "深证成指", "创业板指", "沪深300"],
            setZsTitle: "上证指数",

            ggt_h: [], //港股通沪
            ggt_h_jlr: [], //港股通沪  净流入
            ggt_h_wcj: [], //港股通沪  未成交

            ggt_s: [], //港股通深
            ggt_s_jlr: [], //港股通深 净流入
            ggt_s_wcj: [], //港股通深 未成交

            nxzj: [], //南向资金
            nxzj_jlr: [], //南向资金  净流入
            nxzj_wcj: [], //南向资金  未成交

            ggth_ye: [], //沪股通余额
            ggts_ye: [], //深股通余额
            desc: [],
            // 底部
            nxzj_hj: "",
            ggt_h_hj: "",
            ggt_s_hj: "",

            zs: [], //指数

            xDataInfo: [],
            yDataHj: [],
            yDataGGTH: [],
            yDataGGTS: [],
            yDataZs: [],
            timeInfo: [],
            MINUTES: 370, //沪深一天的交易时间
            AM_MINUTES: 180, //沪深上午交易时间
            showInfo: true,
        };
    },
    computed: {
        ...mapState(["altogether"]),
    },
    watch: {
        altogether: {
            deep: true,
            handler () {
                this.pagealtogether = this.$store.state.altogether;

            }
        }
    },
    filters: {
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixData: function (v) {
            if (v == undefined || v == null|| v == '--'|| v == '----') return "--";
            else if (v > 0) return "+" + (v / 100000000).toFixed(2)+'亿';
            else if (v < 0) return (v / 100000000).toFixed(2)+'亿';
            else{
                return v;
            }
        },

        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
    },
    created() {
        for (var i = 0; i <= this.MINUTES; i++) {
            this.timeInfo.push(this.convertXToTime(i));
        }
    },
    mounted: function () {
        // this.drawLine();
        this.getToDayNxzj();
        // this.getToDayZjye();
        this.pagealtogether = this.$store.state.altogether;
    },
    methods: {
        // 折现图X轴 时间计算
        addZero: function (str, length) {
            return (
                new Array(length - str.toString().length + 1).join("0") + str
            );
        },
        convertXToTime: function (x) {
            var startAm = new Date(1970, 1, 1, 9, 0, 0);
            var startPm = new Date(1970, 1, 1, 13, 0, 0);
            var endXAm = this.AM_MINUTES; //上午交易时间段对应的最后一个x序列的值(2个小时,120分钟)
            var time = "";
            if (x <= endXAm) {
                time = new Date(+startAm + 60000 * x); //获得当前时间=起始时间 + 1分钟 * X
            } else {
                time = new Date(+startPm + 60000 * (x - endXAm)); //获得当前时间=起始时间 + 1分钟 * (X - 上午最后一个X - 1)
            }

            return [
                this.addZero(time.getHours(), 2),
                this.addZero(time.getMinutes(), 2),
            ].join(":");
        },

        // 南向资金- 港股通 折线图
        drawLine: function () {
            console.log('123',123);
            var _this = this;
            var chartDom = document.getElementById("line");
            // var myChart = this.$echarts.init(chartDom);
            this.myChart = this.$echarts.init(chartDom);
            var curZJToday = this.curZJToday;
            var option;
            var setZsTitle = _this.setZsTitle;
            option = {
                color: ["#1677FF", "#FF6010", "#EA46FF"],
                tooltip: {
                    show: true, // 是否显⽰
                    trigger: "axis", // 触发类型  'item'图形触发：散点图，饼图等⽆类⽬轴的图表中使⽤； 'axis'坐标轴触发；'none'：什么都不触发。
                    triggerOn: "mousemove",
                    alwaysShowContent: false,

                    formatter: function (params) {
                        var string = "";
                        if (
                            params[0] !== undefined &&
                            !isNaN(params[0].value)
                        ) {
                            string +=
                                params[0].marker +
                                params[0].seriesName +
                                params[0].value +
                                "亿<br/>";
                        }
                        if (
                            params[1] !== undefined &&
                            !isNaN(params[1].value)
                        ) {
                            string +=
                                params[1].marker +
                                params[1].seriesName +
                                params[1].value +
                                "亿<br/>";
                        }
                        if (params[2] !== undefined) {
                            if (!isNaN(params[2].value)) {
                                string +=
                                    params[2].marker +
                                    params[2].seriesName +
                                    params[2].value +
                                    "亿<br/>";
                            }
                        }

                        return string == ""
                            ? false
                            : params[0].name + "<br/>" + string;
                    },
                },
                grid: {
                    left: 0,
                    right: 10,
                    bottom: "3%",
                    top: 25,
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: _this.timeInfo,
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                    axisLabel: {
                        color: "#999",
                        //interval: 59,
                        interval: function (index) {
                            //index是x轴的坐标序号，name是坐标值
                            var timeLength = _this.timeInfo.length - 1;
                            if (index == 0) {
                                return true;
                            }
                            if (index == timeLength) {
                                return true;
                            }
                        },
                        textStyle: { color: "#ccc", fontSize: 13 },

                        formatter: function (value, index) {
                            //文本格式化
                            if (index === 0) {
                                return "{right|" + value + "}";
                            } else if (index === 4) {
                                return "{left|" + value + "}";
                            } else {
                                return "{center|" + value + "}";
                            }
                        },
                        rich: {
                            right: {
                                width: 80,
                                fontSize: 10,
                                align: "right",
                            },
                            left: {
                                width: 100,
                                fontSize: 10,
                                align: "left",
                            },
                            center: {
                                fontSize: 10,
                                align: "center",
                            },
                        },
                        padding: [0, 20, 0, 0],
                    },

                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        splitNumber: 5,
                        gridIndex: 0,
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: function (value) {
                                if (value > 10) {
                                    return Math.trunc(value) + "亿";
                                } else {
                                    return value + "亿";
                                }
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                type: "dashed",
                                color: "#C8C8C8",
                            },
                        },
                        min: function (value) {
                            if (curZJToday == 2) {
                                var minInfo = value.min - 10;
                            } else {
                                if (value.min > 0) {
                                    var minInfo = value.min - value.min * 0.2;
                                } else {
                                    var minInfo = value.min + value.min * 0.2;
                                }
                            }

                            return Math.round(minInfo);
                        },
                        max: function (value) {
                            if (curZJToday == 2) {
                                return Math.round(value.max + 10);
                            } else {
                                return Math.round(value.max + value.max * 0.2);
                            }
                        },
                    },
                    {
                        type: "value",
                        alignTicks: true,
                        position: "right",
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: "{value}",
                        },
                        splitLine: { show: false },
                    },
                ],
                series: [
                    {
                        name: "合计",
                        type: "line",
                        symbol: "none",
                        data: _this.yDataHj,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    width: 1.5, // 0.1的线条是非常细的了
                                },
                            },
                        },
                    },
                    {
                        name: "港股通(沪)",
                        type: "line",
                        symbol: "none",
                        data: this.yDataGGTH,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    width: 1, // 0.1的线条是非常细的了
                                },
                            },
                        },
                    },
                    {
                        name: "港股通(深)",
                        type: "line",
                        symbol: "none",
                        data: this.yDataGGTS,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    width: 1, // 0.1的线条是非常细的了
                                },
                            },
                        },
                    },
                ],
            };
            setTimeout(function () {
                // myChart.setOption(option);
                _this.myChart.setOption(option);
                window.addEventListener("resize", function () {
                _this.myChart.resize();
            });

                _this.myChart.dispatchAction({
                    type: "hideTip",
                });
            });
        },
        chartResize: function () {
            if(this.curZJToday==0){
                var _this = this;
                this.$nextTick(() => {
                    _this.drawLine()
                });
            }
        },

        // 获取南向资金
        // 今日南向资金(资金流向,资金净买入,未成交委买)
        getToDayNxzj: function () {
            var _this = this;
            var response = "";
            nxzjmin().then((res) => {
                this.$nextTick(() => {
                    if (res.data.err == 0) {
                        response = res.data.data;
                        var ggt_h,
                            ggt_h_jlr,
                            ggt_h_wcj,
                            ggt_s,
                            ggt_s_jlr,
                            ggt_s_wcj,
                            nxzj,
                            nxzj_jlr,
                            nxzj_wcj;
                        var nxzjLength = response.nxzj.length;
                        if (nxzjLength < 30) {
                            _this.timeInfo = _this.timeInfo.slice(0, 31);
                        }
                        for (var i = 0; i < response.nxzj.length; i++) {
                            //资金流向
                            nxzj = (response.nxzj[i] / 100000000).toFixed(2);
                            ggt_h = (response.ggt_h[i] / 100000000).toFixed(2);
                            ggt_s = (response.ggt_s[i] / 100000000).toFixed(2);

                            _this.nxzj.push(nxzj);
                            _this.ggt_h.push(ggt_h);
                            _this.ggt_s.push(ggt_s);

                            //资金净流入
                            nxzj_jlr = (
                                response.nxzj_jlr[i] / 100000000
                            ).toFixed(2);
                            ggt_h_jlr = (
                                response.ggt_h_jlr[i] / 100000000
                            ).toFixed(2);
                            ggt_s_jlr = (
                                response.ggt_s_jlr[i] / 100000000
                            ).toFixed(2);
                            _this.nxzj_jlr.push(nxzj_jlr);
                            _this.ggt_h_jlr.push(ggt_h_jlr);
                            _this.ggt_s_jlr.push(ggt_s_jlr);

                            // 资金未成交
                            nxzj_wcj = (
                                response.nxzj_wcj[i] / 100000000
                            ).toFixed(2);
                            ggt_h_wcj = (
                                response.ggt_h_wcj[i] / 100000000
                            ).toFixed(2);
                            ggt_s_wcj = (
                                response.ggt_s_wcj[i] / 100000000
                            ).toFixed(2);

                            _this.nxzj_wcj.push(nxzj_wcj);
                            _this.ggt_h_wcj.push(ggt_h_wcj);
                            _this.ggt_s_wcj.push(ggt_s_wcj);
                        }

                        _this.desc = response.desc;

                        _this.nxzj_hj = (_this.desc.nxzjjlr / 100000000).toFixed(
                            2
                        );
                        _this.ggt_h_hj = (
                            _this.desc.ggt_h_jlr / 100000000
                        ).toFixed(2);
                        _this.ggt_s_hj = (
                            _this.desc.ggt_s_jlr / 100000000
                        ).toFixed(2);

                        // 折线图数据(现在要默认净流入)
                        _this.yDataHj = this.nxzj_jlr;
                        _this.yDataGGTH = this.ggt_h_jlr;
                        _this.yDataGGTS = this.ggt_s_jlr;
                        // _this.yDataHj = this.nxzj;
                        // _this.yDataGGTH = this.ggt_h;
                        // _this.yDataGGTS = this.ggt_s;

                        if (this.nxzj.length == 0) {
                            this.showInfo = false;
                        } else {
                            _this.getYunSpj(1);
                        }
                    }
                });
            });
        },

        // 查询南向资金(资金余额)
        getToDayZjye: function () {
            var _this = this;
            var response = "";
            nxzjyemin().then((res) => {
                this.$nextTick(() => {
                    if (res.data.err == 0) {
                        response = res.data.data;
                        var ggth_ye, ggts_ye;
                        for (var i = 0; i < response.ggt_h_ye.length; i++) {
                            ggth_ye = (
                                response.ggt_h_ye[i] / 100000000
                            ).toFixed(2);
                            ggts_ye = (
                                response.ggt_s_ye[i] / 100000000
                            ).toFixed(2);

                            _this.ggth_ye.push(ggth_ye);
                            _this.ggts_ye.push(ggts_ye);
                        }
                    }
                });
            });
        },

        // table 切换
        setTable: function (item, i) {
            this.curZJToday = i;
            this.showInfo = true;
            // if (i == 0) {
            //     this.nxzj_hj = (this.desc.nxzjlr / 100000000).toFixed(2);
            //     this.ggt_h_hj = (this.desc.ggt_h_lr / 100000000).toFixed(2);
            //     this.ggt_s_hj = (this.desc.ggt_s_lr / 100000000).toFixed(2);

            //     this.yDataHj = this.nxzj;
            //     this.yDataGGTH = this.ggt_h;
            //     this.yDataGGTS = this.ggt_s;
            //     this.yDataZs = this.zs;
            //     if (this.yDataHj.length == 0) {
            //         this.showInfo = false;
            //     } else {
            //         this.drawLine();
            //     }
            // } else if (i == 1) {
            //     this.nxzj_hj = (this.desc.nxzjjlr / 100000000).toFixed(2);
            //     this.ggt_h_hj = (this.desc.ggt_h_jlr / 100000000).toFixed(2);
            //     this.ggt_s_hj = (this.desc.ggt_s_jlr / 100000000).toFixed(2);
            //     //资金净流入
            //     this.yDataHj = this.nxzj_jlr;
            //     this.yDataGGTH = this.ggt_h_jlr;
            //     this.yDataGGTS = this.ggt_s_jlr;
            //     this.yDataZs = this.zs;
            //     if (this.yDataHj.length == 0) {
            //         this.showInfo = false;
            //     } else {
            //         this.drawLine();
            //     }
            // } else if (i == 2) {
            //     this.ggt_h_hj = (this.desc.ggt_h_ye / 100000000).toFixed(2);
            //     this.ggt_s_hj = (this.desc.ggt_s_ye / 100000000).toFixed(2);
            //     this.nxzj_hj = (
            //         (this.desc.ggt_h_ye + this.desc.ggt_s_ye) /
            //         100000000
            //     ).toFixed(2);
            //     //余额
            //     this.yDataHj = [];
            //     this.yDataGGTH = this.ggth_ye;
            //     this.yDataGGTS = this.ggts_ye;
            //     this.yDataZs = this.zs;
            //     if (this.yDataGGTH.length == 0) {
            //         this.showInfo = false;
            //     } else {
            //         this.drawLine();
            //     }
            // } else if (i == 3) {
            //     this.nxzj_hj = (this.desc.nxzjwcj / 100000000).toFixed(2);
            //     this.ggt_h_hj = (this.desc.ggt_h_wcj / 100000000).toFixed(2);
            //     this.ggt_s_hj = (this.desc.ggt_s_wcj / 100000000).toFixed(2);
            //     //未成交
            //     this.yDataHj = this.nxzj_wcj;
            //     this.yDataGGTH = this.ggt_h_wcj;
            //     this.yDataGGTS = this.ggt_s_wcj;
            //     this.yDataZs = this.zs;
            //     if (this.yDataHj.length == 0) {
            //         this.showInfo = false;
            //     } else {
            //         this.drawLine();
            //     }
            // }
            debugger;
            // 资金流入
            if (i == 0) {
                this.nxzj_hj = (this.desc.nxzjjlr / 100000000).toFixed(2);
                this.ggt_h_hj = (this.desc.ggt_h_jlr / 100000000).toFixed(2);
                this.ggt_s_hj = (this.desc.ggt_s_jlr / 100000000).toFixed(2);


                //资金净流入
                this.yDataHj = this.nxzj_jlr;
                this.yDataGGTH = this.ggt_h_jlr;
                this.yDataGGTS = this.ggt_s_jlr;
                this.yDataZs = this.zs;
                if (this.yDataHj.length == 0) {
                    this.showInfo = false;
                } else {
                    this.drawLine();
                }
            } else if (i == 1) {
                // this.ggt_h_hj = (this.desc.ggt_h_ye / 100000000).toFixed(2);
                // this.ggt_s_hj = (this.desc.ggt_s_ye / 100000000).toFixed(2);
                // this.nxzj_hj = (
                //     (this.desc.ggt_h_ye + this.desc.ggt_s_ye) /
                //     100000000
                // ).toFixed(2);
                //余额
                // this.yDataHj = [];
                // this.yDataGGTH = this.ggth_ye;
                // this.yDataGGTS = this.ggts_ye;
                // this.yDataZs = this.zs;
                // if (this.yDataGGTH.length == 0) {
                //     this.showInfo = false;
                // } else {
                //     // this.drawLine();
                // }
            }


            this.chartResize();
        },
        setZs: function (title, i) {
            var _this = this;
            this.LineMoreIndex = i;
            this.setZsTitle = title;
            this.getYunSpj(i);
            // setTimeout(function () {
            //     _this.drawLine();
            // }, 1000);
        },
        // 获取云平台资金流向K线
        getYunSpj: function (i) {
            var obj = "SH000001";
            if (i == 0) {
                // 上证
                obj = "SH000001";
            } else if (i == 1) {
                // 深证
                obj = "SZ399001";
            } else if (i == 2) {
                //创业板指
                obj = "SZ399006";
            } else {
                obj = "SH000300";
            }

            var myDate = new Date();
            var response = "";
            function vertDate(obj) {
                //日期转yyyy-MM-dd
                var date = new Date(obj);
                var y = 1900 + date.getYear();
                var m = "0" + (date.getMonth() + 1);
                var d = "0" + date.getDate();
                return (
                    y +
                    "" +
                    m.substring(m.length - 2, m.length) +
                    "" +
                    d.substring(d.length - 2, d.length)
                );
            }
            var date1 = vertDate(myDate);

            var params = {
                obj: obj,
                begin_time: date1 + "-091000",
            };

            var _this = this;
            _this.zs = [];
            getYunSpjToSf(params).then((res) => {
                _this.zs = [];
                this.$nextTick(() => {
                    setTimeout(function () {
                        if (res.data.err == 0) {
                            response = res.data.data;

                            var lenInfo = 20;
                            var zsQin = "0.00";
                            // for (var j = 0; j < lenInfo; j++) {
                            //     // _this.zs.push(zsQin);
                            //     _this.zs = _this.zs.concat(zsQin);
                            // }
                            var zsInfo;
                            for (var i = 0; i < response.length; i++) {
                                zsInfo = response[i][1].toFixed(2);
                                // _this.zs.push(zsInfo);
                                _this.zs = _this.zs.concat(zsInfo);
                            }
                        } else {
                            _this.zs = [];
                        }
                        setTimeout(function () {
                            _this.drawLine();
                        });
                    });
                });
            });
        },
    },
};
</script>
